import { all } from "redux-saga/effects";
import * as watchers from "./watchers";

export function* courseAuthorSagas() {
  yield all([
    watchers.watchAddImmersiveBackground(),
    watchers.watchAddListItem(),
    watchers.watchAddOrderItem(),
    watchers.watchChangeListItemAnswers(),
    watchers.watchChooseSingleChoiceQuestionAnswer(),
    watchers.watchCloneCourse(),
    watchers.watchCreateStyle(),
    watchers.watchDeleteImmersiveBackground(),
    watchers.watchFetchAllOrganizations(),
    watchers.watchFetchAdministrableOrgIds(),
    watchers.watchFetchAdministrableOrgs(),
    watchers.watchFetchCourse(),
    watchers.watchFetchCourseChanges(),
    watchers.watchMigrateContentToHtml(),
    watchers.watchMount(),
    watchers.watchPatchCourse(),
    watchers.watchPatchCoursePlayer(),
    watchers.watchPatchStyle(),
    watchers.watchRequestPreviewCourseInst(),
    watchers.watchResolveAuxiliaryData(),
    watchers.watchSimplePatchCourse(),
    watchers.watchSortPart(),
    watchers.watchSortColumnPosition(),
    watchers.watchUnmount(),
    watchers.watchUpdateFullCourse(),
    watchers.watchImportTranslationsCsv(),
  ]);
}
